import { inProgressStatuses } from '@/constants/ticketing'
import type {
	MappedTicket, TicketInProgressStatus, TicketsApiResponse
} from '@/types/ticketing'
import { formatDate, formatIsoStringWithTimeZoneOffset } from '@/utils/formatDate'

const isTicketOverdue = (status: TicketInProgressStatus, dueDate: string | undefined) => {
	const rightNow = new Date()
	if (!inProgressStatuses.includes(status)) {
		return false
	}
	const due = dueDate ? new Date(dueDate) : null
	return !!due && due < rightNow
}

const mapTickets = (tickets: TicketsApiResponse[]): MappedTicket[] => {
	const formatDueDate = (dueDate: string | undefined) => {
		// #TODO: this shouldn't be necessary once all tickets with old format are resolved
		if (!dueDate) {
			return null
		}
		return dueDate.includes('T') ? formatDate(dueDate) : formatIsoStringWithTimeZoneOffset(dueDate)
	}

	return tickets?.map(({
		_id,
		status,
		priority,
		dueDate,
		accountId,
		accountName,
		assignee,
		assigneeId,
		category,
		content,
		title,
		tier,
		escalated,
		created,
		createdTime,
		updated,
		metaDataDates,
		author
	}) => {
		return {
			id: _id?.$oid || '',
			status,
			priority,
			lastUpdated: formatDate(updated) || formatDate(metaDataDates?.updated) || null,
			created: formatDate(createdTime) || formatDate(created) || formatDate(metaDataDates?.created) || null,
			dueDate: formatDueDate(dueDate),
			accountId,
			accountName,
			assigneeId: assigneeId || (assignee?.id || '').toString(), // NOTE support both the old assignee object and just storing the id for now
			assignee: `${assignee?.firstName} ${assignee?.lastName}`,
			category,
			content,
			title,
			navigateTo: `/accounts/${accountId}/ticketing/${_id?.$oid}`,
			overdue: isTicketOverdue(status as TicketInProgressStatus, dueDate),
			tier,
			escalated: formatDate(escalated) || null,
			author: `${author.firstName} ${author.lastName}`
		}
	}) || []
}

export { isTicketOverdue, mapTickets }
